import { Component, ViewEncapsulation, inject } from "@angular/core";
import { WcmService } from "@shared/services/wcm/wcm.service";

@Component({
	selector: "app-header",
	templateUrl: "./header.component.html",
	styleUrl: "./header.component.scss",
	encapsulation: ViewEncapsulation.None,
	standalone: false
})
export class HeaderComponent {
	protected wcmService = inject(WcmService);
}